module.exports = __webpack_public_path__ + "static/media/S3N9-4.8fc164a7.svg";